module.exports = __webpack_public_path__ + "static/media/common_mom_default.c751a057.png";